import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div``;

export const AddPostContainer: StyledComponent<'div'> = styled.div`
  max-width: 408px;
`;

export const AddPostButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Color.Gray100};
  padding: 17px 0;
  border-bottom: 1px solid ${Color.Gray300};
  width: 100%;
  position: relative;
  margin-top: 10px;
`;

export const AddPostButtonLabel: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Gray500};
  margin-left: 10px;
`;

export const RelatedNewsContainer: StyledComponent<'div'> = styled.div`
  margin-top: 40px;
`;

export const RelatedNewsHeader: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${Color.Black};
  background-color: ${Color.Gray100};
  padding: 26px 16px 14px;
  border-bottom: 1px solid ${Color.Gray300};
`;

export const NewsRow: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 16px;
  background-color: ${Color.Gray100};

  & + & {
    border-top: 1px solid ${Color.Gray300};
  }

  &:last-of-type {
    border-bottom: 1px solid ${Color.Gray300};
  }
`;

export const NewsCell: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 12px;
  background: ${Color.White};
  border: 1px solid ${Color.Gray300};
  border-radius: 50px;
`;

export const NewsLabel: StyledComponent<'div'> = styled.div`
  margin-left: 5px;
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Gray500};
`;

export const NewsRemoveButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })``;
